// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__uM9om","filesListContainer":"PosDisputesFiles_filesListContainer__145XI","filesButton":"PosDisputesFiles_filesButton__1kVqR"};